var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmartpage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 199,
    viewBox: "0 0 183 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 199,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.911 107.46L91.2747 153.096L136.911 198.733L182.548 153.096L136.911 107.46Z",
    fill: "#00DEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6367 107.464L0 153.101L45.6367 198.738L91.2733 153.101L45.6367 107.464Z",
    fill: "#00DEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.901 107.448L136.421 107.948L136.911 107.458L136.901 107.448Z",
    fill: "#313894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6312 107.458L46.1012 107.928L45.6412 107.448L45.6312 107.458Z",
    fill: "#313894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.421 107.948L135.731 108.638L136.421 107.948Z",
    fill: "#51C4D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8212 108.648L46.1012 107.928L46.8212 108.648Z",
    fill: "#51C4D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.901 107.448C144.114 99.9807 149.383 90.8566 152.245 80.8771C155.107 70.8976 155.474 60.368 153.315 50.2132C151.155 40.0585 146.535 30.5894 139.86 22.6378C133.186 14.6862 124.66 8.49541 115.033 4.60928C105.406 0.723151 94.9722 -0.739404 84.6477 0.350102C74.3233 1.43961 64.4243 5.04783 55.8205 10.8578C47.2167 16.6678 40.1713 24.5017 35.3032 33.6714C30.4351 42.8411 27.8934 53.0659 27.9012 63.4477V63.4477C27.8802 79.8627 34.2458 95.6422 45.6512 107.448L91.3212 61.8177L136.901 107.448Z",
    fill: "#008AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3212 61.8177L45.6412 107.448L46.1012 107.928L46.8212 108.648L91.3212 153.098L135.781 108.638L136.471 107.948L136.951 107.448L91.3212 61.8177Z",
    fill: "#1100B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 199,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmartpage);
export default __webpack_public_path__ + "static/media/logoSmartpage.5fc28cca5fc947034ab24a80a7c90760.svg";
export { ForwardRef as ReactComponent };